import { ROUTE_SEO_ADDRESS } from '..'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { generateFullRoute } from '../../domain/router/route.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params: { code, town } }) => {
  throw new PermanentRedirectError(generateFullRoute(ROUTE_SEO_ADDRESS, { location: `${code}-${town}` }))
}

const renderPage = () => {
  return null
}

export default handleRouteLoading({ onRouteEnter, renderPage })
